/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import Status from 'containers/Status';
import TextFormatter from 'utils/TextFormatter';

const TechInfo = (props) => {
    const {tech, currentUserId} = props;
    if (!tech) {
        return null;
    }

    const techPhoneFormatted = TextFormatter.formatPhoneNumber(tech.getIn(['info', 'cellPhone']));
    const techPhoneDial = TextFormatter.cleanPhoneNumber(tech.getIn(['info', 'cellPhone']));
    return (

        <div>

            <table>
                <tbody>
                    <tr>

                        <td
                            style={{
                            width: '40%'
                        }}>
                            <b>
                                {`${tech.getIn(['info', 'firstName'])} ${tech.getIn(['info', 'lastName'])}`}</b>
                            <br/>
                            <a target="_blank" href={'tel:' + techPhoneDial}>
                                {techPhoneFormatted}
                            </a>
                        </td>

                        <td
                            style={{
                            paddingTop: '25px',
                            width: '60%'
                        }}>

                            <Status
                                buttonTextColor="black"
                                userId={tech.getIn(['info', 'userId'])}
                                currentUserId={currentUserId}/>

                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2">Garage: {tech.getIn(['info', 'marketId'])}-{tech.getIn(['info', 'garage'])}</td>

                    </tr>
                </tbody>
            </table>

        </div>
    );
};
TechInfo.propTypes = {
    tech: PropTypes.object,
    currentUserId: PropTypes.string
};

export default TechInfo;


// WEBPACK FOOTER //
// ./src/components/tech/TechInfo.js